export const createStyles = () => {
  return {
    listWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      pb: '16px',
    },
  };
};
